import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from 'src/app/modules/cpg/login/login.component';
import { DistributorLoginComponent } from 'src/app/modules/distributor/distributor-login/distributor-login.component';
import { PageNotFoundComponent } from './modules/core/page-not-found/page-not-found.component';


const routes: Routes = [
  { path: '', redirectTo: '/retailer', pathMatch: 'full' },
  { path: 'cpg', component: LoginComponent },
  { path: 'distributor', component: DistributorLoginComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
